import React, { useState, useEffect } from "react";
import light_cal from "../../Assests/images/light_calculator.png";
import LeadCaptureModal from "../../Componenets/LeadCaptureModal";
import { useNavigate } from "react-router-dom";
function FicaCalculator() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [employees, setEmployees] = useState(0);
  const [fullTime, setFullTime] = useState(0);
  const [partTime, setPartTime] = useState(0);
  const [total, setTotal] = useState(0);

  // Calculate total whenever inputs change
  useEffect(() => {
    const fullTimeValue = fullTime * 5200;
    const partTimeValue = partTime * 2600;

    const finalTotal = fullTimeValue + partTimeValue;
    setTotal(finalTotal);
  }, [employees, fullTime, partTime]);

  return (
    <>
      <section className="calculator">
        <div className="container py-5">
          <h1 className="text-center fw-bold mb-3">
            FICA Tip Credit Calculator
          </h1>
          <p className="text-center text-muted mb-5 fifa_p">
            Calculate how much FICA tax credit your restaurant can claim based
            on employee tips. This calculator is based on IRS Section 45B, which
            allows employers to claim a credit for the FICA taxes paid on tips
            that exceed the federal minimum wage.
          </p>
          {/* INPUT ROW */}
          <div className="row g-4">
            {/* Employees */}
            <div className="col-md-4">
              <div className="p-4 border rounded shadow-sm bg-white">
                <label className="fw-semibold mb-2">
                  <i className="fa-regular fa-user me-2"></i>
                  Number Of Restaurant Locations
                </label>

                <input
                  type="number"
                  className="form-control"
                  id="noofemployees"
                  onChange={(e) => setEmployees(Number(e.target.value))}
                />
              </div>
            </div>

            {/* Full Time */}
            <div className="col-md-4">
              <div className="p-4 border rounded shadow-sm bg-white">
                <label className="fw-semibold mb-2">
                  <i className="fa-solid fa-dollar me-2 text-primary"></i>
                  Number of Full Time Servers
                </label>

                <input
                  type="number"
                  className="form-control"
                  id="fulltimeServers"
                  onChange={(e) => setFullTime(Number(e.target.value))}
                />
              </div>
            </div>

            {/* Part Time */}
            <div className="col-md-4">
              <div className="p-4 border rounded shadow-sm bg-white">
                <label className="fw-semibold mb-2">
                  <i className="fa-solid fa-dollar me-2 text-primary"></i>
                  Number of Part Time Servers
                </label>

                <input
                  type="number"
                  className="form-control"
                  id="parttimeServers"
                  onChange={(e) => setPartTime(Number(e.target.value))}
                />
              </div>
            </div>
          </div>

          {/* RESULT BOX */}
          <div className="mt-5 p-4 rounded shadow bg-light position-relative estimated_value">
            <h5 className=" fw-bold">Estimated 3 Year FICA Refund / Credit</h5>

            <h1 className="fw-bold " id="addvalue">
              ${total.toLocaleString()}
            </h1>

            <div className="mt-3 d-flex gap-3">
              <button
                className="btn btn-outline-primary btn_learnmore px-4"
                style={{ cursor: "pointer" }}
                onClick={() =>navigate("/")}
              >
                Learn More
              </button>
              <button
                className="btn btn-primary btn_getstarted px-4"
                style={{ cursor: "pointer" }}
                 onClick={() => setShowModal(true)}
              >
                Get Started
              </button>
            </div>
          </div>
          <div className="mt-4 p-4 rounded border bg-white d-flex align-items-center shadow-sm">
            <img src={light_cal} className="img-fluid me-2" alt="" />
            <p className="mb-0">
              This calculator is based on IRS Section 45B, which allows
              employers to claim a credit for the FICA taxes paid on tips that
              exceed the federal minimum wage.
            </p>
          </div>
          {/* INFO BOX */}
          <div
            className="mt-4 p-4 rounded border d-flex align-items-center shadow-sm"
            style={{ backgroundColor: "#F8F0E2" }}
          >
            <i className="fa-solid fa-circle-info text-warning fs-4 me-3"></i>
            <p className="mb-0">
              Note: This is an estimation tool. Please consult with a tax
              professional for specific advice regarding your tax situation.
            </p>
          </div>
        </div>
      </section>
      <LeadCaptureModal showModal={showModal} setShowModal={setShowModal} />
    </>
  );
}

export default FicaCalculator;
